export default function tracker(
  method: "trackSingleCustom" | "trackCustom" | "track" | "trackSingle",
  event: string,
  data?: any,
  eventID?: string,
  customPixel?: string
) {
  const pixelIds = [
    process.env.NEXT_PUBLIC_FB_PIXEL_NEW_ID,
    process.env.NEXT_PUBLIC_FB_PIXEL_NEW_ID_11_25,
  ];

  if (typeof fbq !== "undefined" && fbq && !customPixel) {
    pixelIds.forEach((pixelId) => {
      fbq(method, pixelId as string, event, data, { eventID });
    });
  }
  else{
    fbq(method, customPixel as string, event, data, { eventID });
  }
  if (event == "Lead") {
    if (typeof gtag !== "undefined" && gtag) {
      gtag("event", "generate_lead", { send_to: "G-DE9JLYGSSZ" });
    }
  } else {
    if (typeof gtag !== "undefined" && gtag) {
      gtag("event", event, { send_to: "G-DE9JLYGSSZ" });
    }
  }
}
